import * as React from 'react';
import { DayPicker, type DayPickerRangeProps } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar(props: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays
      className="rounded-md border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-3 text-[var(--anl-text)]"
      {...props}
    />
  );
}

export type { DayPickerRangeProps };
export type { DateRange } from 'react-day-picker';
